import { defineStore } from 'pinia'

export const useCompanyStore = defineStore('company', {
  state: () => {
    return {
      companies: [],
    }
  },
  actions: {},
  getters: {
    getCompanyData(state) {
      return (profileId: number | string) => {
        return state.companies.find(c => c.id === profileId)
      }
    },
    getCompanyTeam(state) {
      return (companyId: number | string) => {
        if (!companyId) return []
        return (
          (state.companies.find(c => c.id === companyId) as any)?.team?.list ||
          {}
        )
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getSellerData(state) {
      return ({
        sellerId,
        companyId,
      }: {
        sellerId: number
        companyId: number
      }) => {
        return this.getCompanyTeam(companyId).find(
          (seller: any) => seller.id === sellerId
        )
      }
    },
  },
})
